<template>
    <div
        v-if="open"
        class="absolute bottom-full left-0 z-30 mb-2 w-full max-w-md overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg"
    >
        <ul class="max-h-60 overflow-y-auto py-1" role="listbox">
            <li
                v-for="(suggestion, index) in suggestions"
                :key="suggestion.key"
            >
                <button
                    type="button"
                    role="option"
                    :aria-selected="index === activeIndex"
                    class="flex w-full cursor-pointer items-baseline gap-2 px-3 py-1.5 text-left transition"
                    :class="
                        index === activeIndex
                            ? 'bg-[#FF421E]/5'
                            : 'hover:bg-gray-50'
                    "
                    @mousedown.prevent="$emit('select', suggestion)"
                    @mouseenter="$emit('hover', index)"
                >
                    <span class="shrink-0 font-mono text-xs text-gray-800">{{
                        suggestion.label
                    }}</span>
                    <span class="truncate text-[11px] text-gray-400">{{
                        suggestion.hint
                    }}</span>
                </button>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
import type { IAiSlashCommandSuggestion } from "@/types/AiChat/IAiSlashCommand";

defineProps<{
    open: boolean;
    suggestions: IAiSlashCommandSuggestion[];
    activeIndex: number;
}>();

defineEmits<{
    (event: "select", suggestion: IAiSlashCommandSuggestion): void;
    (event: "hover", index: number): void;
}>();
</script>
